import React from 'react';
import mammoth from 'mammoth';
import './style.css';
import 'rsuite/dist/styles/rsuite-default.css';
import $ from 'jquery';
import {
  Button,
  Icon,
  PanelGroup,
  Panel,
  Modal,
  Input,
  Notification,
} from 'rsuite';
import Axios from 'axios';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  container: {
    '& table': {
      borderCollapse: 'collapse',
      width: '100%',

      '& th, td': {
        textAlign: 'left',
        borderBottom: '1px solid rgb(233, 233, 233)',
        padding: '10px !important'
      },

      '& td p + p': {
        padding: 0,
        margin: 0
      }
    }
  }
};

class DocProblems extends React.Component {
  static defaultProps = {
    file: null
  };

  constructor(props) {
    super(props);

    this.state = {
      title: '',
      documentData: [],
      selectedProblem: null,
      selectedSpec: '',
      selectedCode: '',
      savedProblems: {},
      modals: {
        showCodeModal: false,
        specsModal: false
      },
      status: {
        reading: false,
        errorMessage: ''
      }
    };

    this.docDataCache = [];
    this.getDocDataCache = this.getDocDataCache.bind(this);
    this.setDocDataCache = this.setDocDataCache.bind(this);
    this.readFileInputEventAsArrayBuffer = this.readFileInputEventAsArrayBuffer.bind(this);
    this.readFile = this.readFile.bind(this);
    this.handleProblemNameChange = this.handleProblemNameChange.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleSelectedCodeChange = this.handleSelectedCodeChange.bind(this);
    this.saveSelectedCode = this.saveSelectedCode.bind(this);
    this.handleSelectedSpecChange = this.handleSelectedSpecChange.bind(this);
    this.addProblemTable = this.addProblemTable.bind(this);
    this.removeProblemTable = this.removeProblemTable.bind(this);
    this.uploadSpec = this.uploadSpec.bind(this);
    this.handleBodyContentEditableFocus = this.handleBodyContentEditableFocus.bind(this);
    this.handleBodyContentEditableKeypressBlur = this.handleBodyContentEditableKeypressBlur.bind(this);

    this.convertTableToSpec = this.convertTableToSpec.bind(this);
    this.reformatTable = this.reformatTable.bind(this);
    this.htmlToText = this.htmlToText.bind(this);
    this.runCode = this.runCode.bind(this);
    this.filterExerciseName = this.filterExerciseName.bind(this);
  }

  componentDidMount() {
    $('body')
      .on('focus', '[contenteditable]', this.handleBodyContentEditableFocus)
      .on('keypress blur', '[contenteditable]', this.handleBodyContentEditableKeypressBlur);
  }

  componentWillUnmount() {
    $('body')
      .off('focus', '[contenteditable]', this.handleBodyContentEditableFocus)
      .off('keypress blur', '[contenteditable]', this.handleBodyContentEditableKeypressBlur);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.file !== this.props.file) {
      this.readFile();
    }
  }

  // gets cached doc data of file
  getDocDataCache(file) {
    for (let cache of this.docDataCache) {
      if (cache.file === file) {
        return cache.data;
      }
    }
    return null;
  }

  // sets the cached doc data of file
  setDocDataCache(file, data) {
    for (let cache of this.docDataCache) {
      if (cache.file === file) {
        cache.data = data;
        return;
      }
    }
    this.docDataCache.push({file, data});
  }

  // reads buffer data of a file
  readFileInputEventAsArrayBuffer(file, callback) {
    const reader = new FileReader();

    reader.onload = function (loadEvent) {
      const arrayBuffer = loadEvent.target.result;
      callback(arrayBuffer);
    };

    reader.readAsArrayBuffer(file.blobFile);
  }

  // reads file and extracts the doc data
  readFile() {
    const file = this.props.file;
    if (file) {
      this.readFileInputEventAsArrayBuffer(file, async (arrayBuffer) => {
        try {
          this.setState({
            status: {
              reading: true,
              errorMessage: ''
            }
          });
          const cacheData = this.getDocDataCache(file);
          const data = await (async () => {
            if (cacheData) {
              return cacheData;
            }

            const data = [];
            const html = await mammoth.convertToHtml({ arrayBuffer: arrayBuffer });
            const md = await mammoth.convertToMarkdown({ arrayBuffer: arrayBuffer });

            const exercises = this.filterExerciseName(md);
            for (let i = 1; i <= exercises.raw.length; i++) {
              let matched;
              let otherFormat = `<strong>${exercises.raw[i - 1].replace(
                / /g,
                '</strong> <strong>'
              )}</strong>`;
              if (i === exercises.raw.length) {
                let relast = new RegExp(
                  `(${exercises.raw[i - 1]}|${otherFormat})([^]*?)$`,
                  'g'
                );
                matched = html.value.match(relast);
              } else {
                let otherFormatEnd = `<strong>${exercises.raw[i].replace(
                  / /g,
                  '</strong> <strong>'
                )}</strong>`;
                let re = new RegExp(
                  `(${exercises.raw[i - 1]}|${otherFormat})([^]*?)(${
                    exercises.raw[i]
                  }|${otherFormatEnd})`,
                  'g'
                );
                matched = html.value.match(re);
              }
              if (matched) {
                let cleanTable = matched[0]
                  .replace(
                    /<td colspan="\d"><\/td>|<td rowspan="\d"><\/td>|<td><\/td>|<tr><\/tr>/g,
                    ''
                  )
                  .replace(/<td([^]*?)>/g, '<td contenteditable="true">');
                let tables = cleanTable.match(/<table([^]*?)\/table>/g);
                tables = this.reformatTable(tables, i - 1);
                data[i - 1] = {
                  name: exercises.filtered[i - 1].replace(/\\/g, ''),
                  tables,
                  code: '',
                  spec: '',
                };
              } else {
                data[i - 1] = {
                  name: exercises.filtered[i - 1].replace(/\\/g, ''),
                  tables: [],
                  code: '',
                  spec: '',
                };
              }
            }
            return data;
          })();
          this.setDocDataCache(file, data);
          this.setState({
            title: file.name.replace(/.docx|.doc/gi, ''),
            documentData: data,
            status: {
              reading: false,
              errorMessage: ''
            }
          });
        }
        catch (e) {
          this.setState({
            status: {
              reading: false,
              errorMessage: e.message
            }
          });
        }
      });
    }
    else {
      this.setState({
        title: '',
        documentData: []
      });
    }
  }

  // handles problem name change
  handleProblemNameChange(e, problemIndex) {
    const documentData = this.state.documentData;
    documentData[problemIndex].name = e.target.value;
    this.setDocDataCache(this.props.file, documentData);
    this.setState({ documentData });
  }

  // opens modal by modal id
  open(id, problemIndex) {
    const {
      modals,
      documentData
    } = this.state;

    modals[id] = true;
    if (id === 'showCodeModal') {
      const code = documentData[problemIndex].code;
      this.setState({
        modals,
        selectedProblem: problemIndex,
        selectedCode: code
      });
    }
    else if (id === 'specsModal') {
      const tables = documentData[problemIndex].tables;
      const spec = JSON.stringify(this.convertTableToSpec(tables), null, 2);
      this.setState({
        modals,
        selectedProblem: problemIndex,
        selectedSpec: spec
      });
    }
  }

  // closes modal by modal id
  close(id) {
    const modals = this.state.modals;
    modals[id] = false;
    this.setState({ modals: modals });
  }

  // handles code change
  handleSelectedCodeChange(value) {
    this.setState({ selectedCode: value });
  }

  // saves code to the doc data
  saveSelectedCode(problemIndex) {
    const { documentData } = this.state;
    documentData[problemIndex].code = this.state.selectedCode;
    this.setDocDataCache(this.props.file, documentData);
    this.setState({ documentData });
    this.close('showCodeModal');
  }

  // handles spec change
  handleSelectedSpecChange(value) {
    const { documentData } = this.state;
    documentData[this.state.selectedProblem].spec = value;
    this.setDocDataCache(this.props.file, documentData);
    this.setState({
      selectedSpec: value,
      documentData
    });
  }

  // adds new table to the problem
  addProblemTable(problemIndex) {
    const { documentData } = this.state;
    const emptyTable = '<table><tr><td><p><strong>Input</strong></p></td><td><p><strong>Output</strong></p></td></tr><tr><td></td><td></td></tr></table>';
    const { tables } = documentData[problemIndex];

    tables.push(emptyTable);
    documentData[problemIndex].tables = this.reformatTable(tables, problemIndex);
    this.setDocDataCache(this.props.file, documentData);
    this.setState({ documentData });
  }

  // removes a table from problem
  removeProblemTable(problemIndex, tableIndex) {
    const { documentData } = this.state;
    documentData[problemIndex].tables.splice(tableIndex, 1);
    this.setDocDataCache(this.props.file, documentData);
    this.setState({ documentData });
  }

  // saves / uploads selected spec
  async uploadSpec() {
    const {
      documentData,
      selectedProblem,
      savedProblems
    } = this.state;
    const problemName = documentData[selectedProblem].name;
    const spec = JSON.parse(this.state.selectedSpec);
    const newSpecifications = {
      id: problemName,
      name: problemName.replace(/-/g, ' '),
      description: problemName,
      data: [...spec.data],
      entry: spec.entry,
      env: spec.env
    };

    try {
      await Axios.post('/admin/spec', newSpecifications);
      Notification['success']({
        title: 'Success',
        description: <div>{problemName} specification created.</div>,
      });
      this.setState({
        savedProblems: { ...savedProblems, [problemName]: true },
      });
      this.close('specsModal');
    } catch (e) {
      Notification['error']({
        title: 'Error',
        description: <div>Failed to create spec: {e.message}</div>,
      });
    }
  }

  // handles focus event of content editable elements inside body
  handleBodyContentEditableFocus(evt) {
    const $this = $(evt.currentTarget);
    $this.data('before', $this.html());
  }

  // handles keypress and blur event of content editable elements inside body
  handleBodyContentEditableKeypressBlur(evt) {
    const el = $(evt.currentTarget);
    const data = $(el).data();
    const isProblemTableField = data.problemIndex !== undefined && data.tableIndex !== undefined;

    if (!isProblemTableField)
      return;

    if (evt.type === 'focusout') {
      const { documentData } = this.state;
      const tableContainer = $(el).closest('.problem-table-container');
      if (tableContainer) {
        documentData[data.problemIndex].tables[data.tableIndex] = $(tableContainer).html();
        this.setDocDataCache(this.props.file, documentData);
        this.setState({ documentData });
      }
    }

    if (evt.keyCode === 13 && evt.shiftKey && el.hasClass('input-td')) {
      const { documentData } = this.state;
      const tableContainer = $(el).closest('.problem-table-container');
      const input = $(el).html();
      const code = documentData[data.problemIndex].code;

      this.runCode(code, input, el);
      evt.preventDefault();

      if (tableContainer) {
        documentData[data.problemIndex].tables[data.tableIndex] = $(tableContainer).html();
        this.setDocDataCache(this.props.file, documentData);
        this.setState({ documentData });
      }
    }
  }

  // util: converts table to spec
  convertTableToSpec(tables) {
    const data = [];

    for (let i = 0; i < tables.length; i++) {
      let table = tables[i];
      let rows = table.match(/<tr([^]*?)\/tr>/g);
      let validRow = true;
      for (let r = 0; r < rows.length; r++) {
        if (
          rows[r].match(/Input|Output|Comments|Comment|Explanation/g) ===
          null &&
          validRow
        ) {
          let cells = rows[r].match(/<td([^]*?)\/td>/g);
          let d = {};
          for (let c = 0; cells && c < cells.length; c++) {
            let value = cells[c]
              .replace(/<br>|<\/br>|<\/p>|<\/div>/g, '\n')
              .replace(/<([^]*?)>/g, '')
              .trim()
              .replace(/\n$/g, '');
            if (cells.length % 2 !== 0) {
              if (c === cells.length - 1) break;
            }
            if (c % 2 === 0) {
              value = value.replace(/\n/g, '');
              d.arguments = [value];
              d.mainInvoker = `main(${value})`;
            }
            if (c % 2 === 1) {
              d.output = value;
              data.push(d);
              d = {};
            }
          }
        }
      }
    }

    const spec = {
      env: 'node',
      entry: 'argv',
      data,
    };
    return spec;
  }

  // util: formats tables
  reformatTable(tables, i) {
    let newTables = [];
    if (!tables) {
      return [];
    }
    tables.forEach((tableHtml, j) => {
      let tr = tableHtml.match(/<tr([^]*?)\/tr>/g);
      let ifValidTable = tableHtml.match(/Input|Output|Comment|Explanation/g);
      if (tr) {
        let headerCount;
        let indexOfOutput;
        tr.forEach((val, k) => {
          if (val.match(/Input|Output|Comment|Explanation/g)) {
            let newVal = val.replace(
              /<td contenteditable="true"([^]*?)>/g,
              '<td>'
            );
            tableHtml = tableHtml.replace(val, newVal);
          }
          let td = val.match(/<td([^]*?)\/td>/g);
          if (td) {
            td.forEach((thead, i) => {
              if (thead.match(/Output/g)) {
                indexOfOutput = i;
              }
            });
          }
          // making sure td length are equal
          if (td && k === 0) {
            headerCount = td.length;
          }
          if (td && headerCount && td.length !== headerCount && indexOfOutput) {
            for (let u = td.length; u < headerCount; u++) {
              td.splice(indexOfOutput, 1, '<td></td>');
            }
            let newVal = val.replace(val, td.join('')); // adding empty td if td length is not equal
            tableHtml = tableHtml.replace(val, newVal);
            indexOfOutput = null;
          }
          if (td && headerCount && td.length !== headerCount) {
            for (let u = td.length; u < headerCount; u++) {
              td.splice(indexOfOutput, 1, '<td></td>');
            }
            let newVal = val.replace(/<td /g, '<td colspan="5"'); //full td width if td length is not equal
            tableHtml = tableHtml.replace(val, newVal);
          }
          //end
          if (
            td &&
            val.match(/Input|Output|Comment|Explanation/g) === null &&
            ifValidTable !== null
          ) {
            td.forEach((val, l) => {
              if (l % 2 === 0) {
                if (td.length % 2 !== 0) {
                  if (l === td.length - 1) return;
                }
                let newVal = val.replace(
                  /<td([^]*?)>/g,
                  `<td class="input-td" id="${i}-${j}" data-problem-index="${i}" data-table-index="${j}" contenteditable="true">`
                );
                tableHtml = tableHtml.replace(val, newVal);
              } else {
                let newVal = val.replace(
                  /<td([^]*?)>/g,
                  `<td id="${i}-${j}" data-problem-index="${i}" data-table-index="${j}" contenteditable="true">`
                );
                tableHtml = tableHtml.replace(val, newVal);
              }
            });
          }
        });
      }
      newTables.push(tableHtml);
    });
    return newTables;
  }

  // util: removes html tags
  htmlToText(html) {
    return html.replace(/<br>|<\/br>/g, '\n').replace(/<[^]*?>/g, '');
  }

  // util: runs / evaluates code
  runCode(code, input, el) {
    if (!code) {
      alert('Add code first.');
      return;
    }
    let inputText = this.htmlToText(input);
    let funcName = (code.match(/(function)*([^]*?)\(/)
        ? code.match(/(function)*([^]*?)\(/)[0].replace(/[( =)>{]|function/g, '')
        : ''
    ).trim();
    let result;
    let codeToRun = `(function(){
    let oldLog = console.log;
    let logs = [];
    console.log = function() {
      logs.push(Array.from(arguments).join(' '));
    };
    ${code};
    let value = ${funcName}(${inputText});
    if(!value){
      value = logs.join('\\n')
    };
    console.log = oldLog;
    return value;
    }())`;
    try {
      result = window.eval(codeToRun);
    } catch (e) {
      result = e;
    }
    let nextSib = el.next();
    result = result ? result.toString().replace(/\n/g, '<br>') : '';
    nextSib.html(result);
  }

  // util: filters exercise name
  filterExerciseName(md) {
    const exerciseNameFiltered = [];
    const exerciseNameFilteredRaw = [];
    // let cleanMD = md.value.replace(
    //   /\n#+ Output\n|\n#+ Input\n|#+ Examples*|_*Examples*_*\n|\n#+ Constraints\n|#* *What to submit\? +\n|_+What to submit\?_+|#* *Hints *\n|_*Hints_*/g,
    //   ""
    // );
    let excerciseName = md.value.match(
      /\n\n## ([^<>]*?)\n\n|\n\n\d\. *__([^<>]*?)__\n\n/g
    );
    if (excerciseName == null) {
      let top = md.value.match(/\b([^]*?)\n\n/);
      excerciseName = [top[0]];
    }
    excerciseName.forEach((ex, i) => {
      exerciseNameFilteredRaw.push(ex.replace(/\d\.|#|_*/g, '').trim());
      ex = ex.replace(/__|#|[.]|\\|\*|"|\//g, '').trim();
      ex = ex
        .replace(/ /g, '-')
        .replace(/-+/g, '-')
        .toUpperCase()
        .replace(/^\d+-/g, '');
      exerciseNameFiltered.push(ex);
    });
    return { filtered: exerciseNameFiltered, raw: exerciseNameFilteredRaw };
  }

  render() {
    const {
      title,
      documentData,
      savedProblems,
      modals,
      selectedProblem,
      status
    } = this.state;
    const { classes } = this.props;

    if (status.reading)
      return (
        <div className="p-4">
          <p>Reading Document...</p>
        </div>
      );

    if (status.errorMessage)
      return (
        <div className="p-4">
          <h4>Unable to read document.</h4>
          <p>{status.errorMessage}</p>
          <div className="pt-3">
            <Button
              onClick={() => this.readFile()}
              appearance="primary"
            >
              Try Again
            </Button>
          </div>
        </div>
      );

    return (
      <>
        <div className={`${classes.container} problems-container`}>
          <h5 className="blue-txt">{title}</h5>
          <div className="problems-body">
            <PanelGroup>
              {documentData.map((val, i) => (
                <Panel
                  header={
                    <div className="panel-controls-container">
                      <h6>
                        {`${i + 1}. `}
                        <input
                          className="problem-name"
                          onChange={(e) => this.handleProblemNameChange(e, i)}
                          value={val.name}
                          placeholder="PI000-E000-Problem-Name"
                        />
                      </h6>
                      {(() => {
                        const saved = savedProblems[val.name] || false;

                        // problem was already saved
                        if (saved) return (
                          <Icon
                            icon="check-circle"
                            style={{ color: 'green', fontSize: '17px' }}
                          />
                        );

                        // problem is not yet saved
                        return (
                          <div className="panel-controls">
                            <p className="small-txt">
                              Tables found: {val.tables ? val.tables.length : 0}
                            </p>
                            <div
                              className="code-btn"
                              onClick={() => this.open('showCodeModal', i)}
                            >
                              <Icon icon="code" style={{ fontSize: '20px' }} />
                            </div>
                            <div
                              className="code-btn"
                              onClick={() => this.addProblemTable(i)}
                            >
                              <Icon icon="plus" style={{ fontSize: '11px' }} />
                            </div>
                            <div
                              className="code-btn"
                              onClick={() => this.open('specsModal', i)}
                              style={{ backgroundColor: '#3498ff' }}
                            >
                              <Icon
                                icon="save"
                                style={{ fontSize: '17px', lineHeight: '10px' }}
                                inverse
                              />
                            </div>
                          </div>
                        );
                      })()}
                    </div>
                  }
                >
                  <ul className="tables-list">
                    {val.tables &&
                    val.tables.map((tableHtml, j) => {
                      return (
                        <li>
                          <Panel shaded style={{ position: 'relative' }}>
                            <div
                              className="close-btn"
                              onClick={() => this.removeProblemTable(i, j)}
                            >
                              <Icon icon="close" />
                            </div>
                            <div
                              key={`table-container${i}-${j}`}
                              id={`table-container${i}-${j}`}
                              className="problem-table-container"
                              dangerouslySetInnerHTML={{
                                __html: tableHtml,
                              }} />
                          </Panel>
                        </li>
                      );
                    })}
                  </ul>
                </Panel>
              ))}
            </PanelGroup>
          </div>
        </div>

        <Modal
          overflow={true}
          show={modals.showCodeModal}
          onHide={() => this.close('showCodeModal')}
        >
          <Modal.Header>
            <Modal.Title>Source Code</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Input
              componentClass="textarea"
              rows={100}
              style={{ width: '100%' }}
              placeholder="Paste code here"
              value={this.state.selectedCode}
              onChange={this.handleSelectedCodeChange}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => this.saveSelectedCode(selectedProblem)}
              appearance="primary"
            >
              Ok
            </Button>
            <Button
              onClick={() => this.close('showCodeModal')}
              appearance="subtle"
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={modals.specsModal}
          onHide={() => this.close('specsModal')}
        >
          <Modal.Header>
            <Modal.Title>Spec</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Input
              componentClass="textarea"
              rows={100}
              style={{ width: '100%', maxHeight: '450px' }}
              placeholder="specs generated"
              value={this.state.selectedSpec}
              onChange={this.handleSelectedSpecChange}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => this.uploadSpec()} appearance="primary">
              Upload
            </Button>
            <Button
              onClick={() => this.close('specsModal')}
              appearance="subtle"
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default withStyles(styles)(DocProblems);
